module.exports = __webpack_public_path__ + "static/media/biomassa_banner.2f97b1db.png";